
import PercentageBar from '@/components/graph/PercentageBar.vue';
import { Icon } from '@/lib/enum/Icon';
import store from '@/store';
import { BatchJob, BatchJobState } from '@/stores/jobs';
import { sortBy } from '@/util/arrayFunctions';
import { pascalCaseToCamelCase } from '@/util/stringFunctions';
import { viewport } from '@/util/windowFunctions';
import { BatchJobLogTypeEnum } from '../../api/v1';

export default {
  name: 'BackgroundJobs',
  components: {
    PercentageBar,
  },
  data() {
    return {
      Icon,
      viewport,
      BatchJobState,
      open: false,
    };
  },
  computed: {
    jobs: (): BatchJob[] =>
      sortBy(store.getters['jobs/backgroundJobs'], '-lastEvent'),
    isInProgress(): boolean {
      return this.jobs.some((j) => j.state === BatchJobState.Running);
    },
    hasErrors(): boolean {
      return this.jobs.some((j) => j.state === BatchJobState.Failed);
    },
  },
  watch: {
    jobs(newJobs, oldJobs) {
      if (newJobs.length > oldJobs.length) {
        this.open = true;
      }
      if (!newJobs.length) {
        this.open = false;
      }
    },
  },
  methods: {
    deleteJob(id: string) {
      store.dispatch('jobs/delete', id);
    },
    getJobName(job: BatchJob): string {
      return (
        {
          [BatchJobLogTypeEnum.ApplyScheduleTemplate]: this.$tc(
            'backgroundJobs.types.applyScheduleTemplate',
          ),
          [BatchJobLogTypeEnum.BulkClockIn]: this.$tc(
            'backgroundJobs.types.bulkClockIn',
          ),
          [BatchJobLogTypeEnum.BulkClockOut]: this.$tc(
            'backgroundJobs.types.bulkClockOut',
          ),
          [BatchJobLogTypeEnum.CopyShifts]: this.$tc(
            'backgroundJobs.types.copyShifts',
          ),
          [BatchJobLogTypeEnum.EmployeeImport]: this.$tc(
            'backgroundJobs.types.employeeImport',
          ),
          [BatchJobLogTypeEnum.EmployeeLeaveSettingsImport]: this.$tc(
            'backgroundJobs.types.importingEmployeeLeaveSettings',
          ),
          [BatchJobLogTypeEnum.PublishShifts]: this.$tc(
            'backgroundJobs.types.publishShifts',
          ),
          [BatchJobLogTypeEnum.RecalculateWorkingTimeLost]: this.$tc(
            'backgroundJobs.types.recalculateWorkingTimeLost',
          ),
          [BatchJobLogTypeEnum.BulkUpdateModels]: this.$tc(
            'backgroundJobs.types.bulkUpdateModels',
            1,
            {
              model: this.$tc(
                `entities.${pascalCaseToCamelCase(job.extra?.model || '')}`,
                2,
              ).toLowerCase(),
            },
          ),
          [BatchJobLogTypeEnum.BulkDeleteModels]: this.$tc(
            'backgroundJobs.types.bulkDeleteModels',
            1,
            {
              model: this.$tc(
                `entities.${pascalCaseToCamelCase(job.extra?.model || '')}`,
                2,
              ).toLowerCase(),
            },
          ),
          [BatchJobLogTypeEnum.ProcessOfflineEvents]: this.$tc(
            'backgroundJobs.types.processOfflineEvents',
          ),
          [BatchJobLogTypeEnum.BulkRecalculateCosts]: this.$tc(
            'backgroundJobs.types.bulkRecalculateCosts',
          ),
        }[job.type] ?? this.$tc('backgroundJobs.types.generic')
      );
    },
  },
};
